'use strict';
mpangoApp.controller('MvendorController',MvendorController); 
function MvendorController($window, $rootScope, $scope ,$state,Mreports, Mvendor, Notification, SweetAlert, $uibModal) {
	$scope.$on('$viewContentLoaded', function () {
        Mvendor.getVendors().success(function  (data,status) {
            $scope.mvendors = data.mvendors;
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    });
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken; 
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num) {};
	$scope.open = function  (templatename,size) {
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{
                tablename:function  () {
                    return $scope.mvendors;
                }
            },
            controller: function  ($scope,tablename, $uibModalInstance) {
                $scope.add = function  (vendordata,valid) {
                    if (valid == true) {
                        $uibModalInstance.close();
                        Mvendor.postVendor(vendordata).success(function  (data,status) {
                            $scope.mvendors = tablename;
                            $scope.mvendors.push(data.insertedD);
                            Notification.success({message: data.message});
                        }).error(function(data,status){
                            $state.go('auth');
                            Notification.error({message: 'Token expired, please login', delay: 3000});
                        }); 
                    }
                };
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
    $scope.update = function(vendordata,formname,index) {
        if (formname == 'vendorupdate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Update vendor data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Mvendor.updateVendor(vendordata,formname).success(function(data) {
                        Notification.success({message: data.message});
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
                }
            });
        }
        if(formname == 'delete'){
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Delete vendor data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes,delete!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Mvendor.updateVendor(vendordata,formname).success(function(data) {
                        $scope.mvendors.splice(index, 1);
                        Notification.success({message: data.message});        
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                    
                } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
                }
            });
            
        }            
    };
}
MvendorController.$inject = ['$window', '$rootScope', '$scope' ,'$state','Mreports', 'Mvendor', 'Notification', 'SweetAlert', '$uibModal'];